
export default {

    init() {

        // TOGGLE SUB NAVIGATION
        const submodules = document.querySelectorAll('.js_mobile_sub_toggle')
        for (let i = 0; i < submodules.length; i++) {
            submodules[i].addEventListener('click', function(e) {
                e.target.classList.toggle('open');
                e.target.parentElement.nextElementSibling.classList.toggle('open');
            });
        }

        // TOGGLE MOBILE NAVIGATION
        //const header = document.getElementById('header');
        const header = document.getElementsByTagName('body')[0];

        document.getElementById('js_nav_mobile_toggle').addEventListener('click', function(e) {
            header.classList.toggle('nav_mobile_open');
        });

        // hack rollover for indurty hover
        const industryItemDe = document.getElementsByClassName('nav__item--industrie')[0]
        const industryItemEn = document.getElementsByClassName('nav__item--industry')[0]
        const historyItemDe  = document.getElementsByClassName('nav__item--historie')[0]
        const historyItemEn  = document.getElementsByClassName('nav__item--history')[0]

        if (industryItemDe) {
            industryItemDe.addEventListener('mouseover', function(e) {
                historyItemDe.getElementsByClassName('nav__link')[0].classList.add('js-toggle')
            })

            industryItemDe.addEventListener('mouseout', function(e) {
                historyItemDe.getElementsByClassName('nav__link')[0].classList.remove('js-toggle')
            })
        }

        if (industryItemEn) {
            industryItemEn.addEventListener('mouseover', function (e) {
                historyItemEn.getElementsByClassName(
                    'nav__link')[0].classList.add('js-toggle')
            })

            industryItemEn.addEventListener('mouseout', function (e) {
                historyItemEn.getElementsByClassName(
                    'nav__link')[0].classList.remove('js-toggle')
            })
        }
    }
}